// dummy wrappers to allow being parsed by
// i18next-parser in next-app for translations
import {
  Trans as TransNext,
  useTranslation as useTranslationNext,
} from "next-i18next";
import {
  Trans as TransReact,
  useTranslation as useTranslationReact,
} from "react-i18next";
import { getPlatform } from "./get-platform";

// If translation must happen on the server side,
// Include this object type with the interpolated text
// And pass it to the t() function when the component is rendered

// Example string: "{{cityName}} is a cool city."
// Example object: interpolation: { cityName: "Some city" }
export type ServersidePropInterpolation = {
  interpolation: { [key: string]: string };
};

/**
 * DUMMY TRANSLATION FUNCTION
 *
 * This is so that the i18next-parser can parse the t() calls in the next-app.
 * You would only use this if you are in an area of the codebase that does not support hooks, but would
 * still like the i18next-parser to parse the t() calls.
 *
 * At runtime, if this function is used directly it will NOT translate the input.
 * @param input
 * @returns input
 */
export const t = (
  input: string,
  _?: { [key: string]: number | string } // eslint-disable-line @typescript-eslint/no-unused-vars
): string => input;

export const useTranslation = (() => {
  const platform = getPlatform();

  switch (platform) {
    case "MOBILE":
    case "DESKTOP":
      return useTranslationReact;
    default:
      // Default to Next.js translation
      return useTranslationNext;
  }
})();

export const getTransComponent = () => {
  const platform = getPlatform();
  switch (platform) {
    case "MOBILE":
    case "DESKTOP":
      return TransReact;
    default:
      return TransNext;
  }
};

export const supportedLocales: string[] = ["en", "fr"];
